import * as React from "react"
import { BookingSummaryContent, type BookingSummaryData } from "./BookingSummaryContent"

export function BookingDisclosure({ summary, onEdit }: { summary: BookingSummaryData | null; onEdit: () => void }) {
    const [open, setOpen] = React.useState(false)
    const contentId = React.useId()
    if (!summary) return null

    return <section className={`ah-booking-disclosure ${open ? "is-open" : ""}`} aria-label="Booking summary">
        <button type="button" className="ah-booking-disclosure-toggle" aria-expanded={open} aria-controls={contentId} onClick={() => setOpen((current) => !current)}>
            <span className="ah-disclosure-thumbnail"><img src={summary.image} alt="" /><b>{summary.quantity}</b></span>
            <span><strong>{summary.quantity} x {summary.productName}</strong><small>{summary.hireLabel} · {summary.postcode}{summary.addonCount > 0 ? ` · ${summary.addonCount} add-on${summary.addonCount === 1 ? "" : "s"}` : ""}</small></span>
            <svg className="ah-disclosure-caret" viewBox="0 0 24 24" aria-hidden="true"><path d="m7 10 5 5 5-5" /></svg>
        </button>
        <div id={contentId} className="ah-booking-disclosure-body" aria-hidden={!open}>
            <div className="ah-booking-disclosure-inner">
                <BookingSummaryContent summary={summary} layout="disclosure" onEdit={onEdit} expanded={open} />
            </div>
        </div>
    </section>
}
